export { default as StrategyProfileHeader } from './StrategyProfileHeader';
